import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';

class SMRoomResource {
  
  static defaultPerPage(){
    return 20;
  }
  
  static getRoom(id, completion){
    const apiClient = new SMRestClient();
    apiClient.get("/1/rooms/" + id + ".json").
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static getRooms(queries, completion){
    queries["per_page"] = queries["per_page"] || this.defaultPerPage();
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/rooms.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static search(queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/search/rooms.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static getReputations(id, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/rooms/"+ id +"/reputations.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static getCalendar(id, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/rooms/"+ id + "/calendar.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static convertConcernsToPayload(form_name, value) {
    const ret = /(.*?)(?:\[(.*)\])?$/.exec(form_name);
    const name = ret[1];
    const keys = ret[2] ? ret[2].split('][') : [];

    keys.slice().reverse().map(function(key, i) {
      let idValue = null;
      if (i % 2 == 0) {
        let target = name + '[' + keys.slice(0, keys.length - (i + 1)).join('][') + ']';
        let jquerySelector = '[name="' +  target + '[id]"]';
        if ($(jquerySelector)) {
          idValue = $(jquerySelector)[0].value;
        }
      }

      if (key == '') {
        value = [value];
      } else {
        let obj = {};
        if (idValue) obj['id'] = idValue;
        obj[key] = value;
        value = obj;
      }
    });

    let payload = {};
    payload[name] = value;

    return payload;
  }
  
  static validateReservation(id, data, completion){
    const url = sprintf("/1/rooms/%s/availabilities.json", id);
    const apiClient = new SMRestClient();
    apiClient.post(url, data).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
    
  }

  static requestReservation(roomId, data, completion){
    const url = sprintf("/1/rooms/%s/reservations.json", roomId);
    const apiClient = new SMRestClient();
    apiClient.post(url, data).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
    
  }
  
  static inquiry(roomId, formData, completion){
    const url = sprintf("/1/rooms/%s/inquiries.json", roomId);
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }
  
}
export default SMRoomResource;


// WEBPACK FOOTER //
// ./app/javascript/resources/SMRoomResource.js